module.exports = __webpack_public_path__ + "static/media/jc.989f5037.webp";